query dateCalcTermWeeks($weeks: Int!, $startDate: Date!) {
  dateCalcTermWeeks(weeks: $weeks, startDate: $startDate)
}
